import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  Button,
} from '@mui/material';

export default function ConfirmFloorPriceDialog({
  open,
  onClose,
  onConfirm,
  title = 'تایید تغییرات حساس',
  message = 'با این اقدام، قیمت‌گذاری بدون سنجش با مرجع اصلی انجام خواهد شد و ریسک مالی افزایش می‌یابد. آیا مطمئن هستید؟',
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      dir="rtl"
      PaperProps={{
        sx: {
          borderRadius: '20px',
          padding: '8px 0',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 800,
          fontSize: '1.1rem',
          color: '#0f172a',
          // borderBottom: '1px solid #f1f5f9',
          pb: 1,
          mb: 1,
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 3, overflowX: 'hidden' }}>
        <Stack spacing={4} sx={{ mt: 1, mb: 3 }}>
          <Typography
            variant="body2"
            sx={{
              color: '#475569',
              lineHeight: 1.8,
              fontWeight: 500,
            }}
          >
            {message}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={2} justifyContent="space-between">
          <Button
            onClick={onClose}
            sx={{
              flex: 1,
              py: 1.2,
              px: 3,
              borderRadius: '12px',
              color: '#64748B',
              fontWeight: 700,
              fontSize: '0.95rem',
              backgroundColor: '#F1F5F9',
              transition: 'all 0.2s',
              '&:hover': {
                backgroundColor: '#FEE2E2',
                color: '#E11D48',
              },
            }}
          >
            انصراف
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{
              flex: 1,
              py: 1.2,
              px: 3,
              borderRadius: '12px',
              color: '#fff',
              fontWeight: 700,
              fontSize: '0.95rem',
              boxShadow: '0 6px 16px rgba(220, 38, 38, 0.25)',
              backgroundColor: '#dc2626',
              transition: 'all 0.2s',
              '&:hover': {
                backgroundColor: '#b91c1c',
                boxShadow: '0 8px 20px rgba(220, 38, 38, 0.4)',
              },
            }}
          >
            تایید
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
